import SignIn from 'containers/Auth/SignIn';
import { addComponentsToRoutes } from 'services/common';
import routes from './routesOnNav';

const components = {
  '/auth/sign-in': SignIn,
};

export default addComponentsToRoutes(routes, components);
